import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

const ContentWrapper = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding: 0;
  margin: 0;
`

const PostMetaItem = ({ icon, iconLabel, text }) => (
  <ContentWrapper>
    <span role="img" aria-label={iconLabel}>
      {icon}
    </span>
    {text}
  </ContentWrapper>
)

PostMetaItem.propTypes = {
  icon: PropTypes.string.isRequired,
  iconLabel: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
}

export default PostMetaItem
